import {Structures} from 'octopus-model';

export const accountManagementSettings = {
    redirectSignup: Structures.object({url: '', target: '_blank'}),
    selfSignup: Structures.boolean(true),
    signup: Structures.boolean(true),
};

export type AccountOverrideSettings = {
    redirectSignup: { url: string, target: string };
};